import React from 'react';
import './App.css';
// import 'bootstrap/dist/css/bootstrap.min.css';
import Navbar from './containers/Navbar/Navbar';
import Footer from './containers/Footer/Footer';
import Router from './Router';
import { AuthContext, initialState, reducer } from './reducers/auth_reducers';

function App() {
  const [state, dispatch] = React.useReducer(reducer, initialState);
  return (
    <AuthContext.Provider
      value={{
        state,
        dispatch
      }}
    >
      <div className="App">
        <Navbar state/>
        <Router />
        {/* <Footer/> */}
      </div>
    </AuthContext.Provider>
  );
}
  
export default App;
